export const PAGE_SIZE = 36;

export const MAIN_FILTER_VALUES = [
  'label',
  'gamma_etat_pur',
  'gamma_bioderma',
  'gamma_esthederm',
  'skin_type',
  'type_of_cosmetic',
  'problems',
  'age',
  'application_area',
  'sun_protection_factor',
  'otdushka',
  'brand'
];

export const BRAND_CATEGORY_PATHS = [
  'catalog/bioderma',
  'catalog/institut-esthederm',
  'catalog/etat-pur'
];
